import { render, staticRenderFns } from "./BatchJobAttributesDistributedShippingLite.vue?vue&type=template&id=eb3a6e8a&"
import script from "./BatchJobAttributesDistributedShippingLite.vue?vue&type=script&lang=js&"
export * from "./BatchJobAttributesDistributedShippingLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
